import React from 'react';
import { Row, Col, Divider, Typography, Avatar } from 'antd';
import { useTranslation } from 'react-i18next';
import moment from 'moment-timezone';

const { Text } = Typography;

const UserInfo = ({ user }) => {
    const { t } = useTranslation();
    if (!user) {
        return null;
    }

    return (
        <>
            <Row gutter={[16, 16]} align="middle">
                <Col xs={24} md={4}>
                    <Avatar
                        src={user.picture_url}
                        size={64}
                        style={{ border: '2px solid #595959' }}
                    />
                </Col>
                <Col xs={24} md={20}>
                    <Row gutter={[16, 16]}>
                        <Col xs={24} md={12}>
                            <Text >{t('full_name')}:</Text>
                            <Text style={{ marginInlineStart: 8 }}>{user.full_name}</Text>
                        </Col>
                        <Col xs={24} md={12}>
                            <Text >{t('email')}:</Text>
                            <Text style={{ marginInlineStart: 8 }}>{user.email}</Text>
                        </Col>
                        <Col xs={24} md={12}>
                            <Text >{t('gender')}:</Text>
                            <Text style={{ marginInlineStart: 8 }}>{user.gender}</Text>
                        </Col>
                        <Col xs={24} md={12}>
                            <Text >{t('locale')}:</Text>
                            <Text style={{ marginInlineStart: 8 }}>{user.locale}</Text>
                        </Col>
                        <Col xs={24} md={12}>
                            <Text >{t('timezone')}:</Text>
                            <Text style={{ marginInlineStart: 8 }}>{user.timezone}</Text>
                        </Col>
                        <Col xs={24} md={12}>
                            <Text >{t('account_active')}:</Text>
                            <Text style={{ marginInlineStart: 8 }}>{user.is_disabled ? t('no') : t('yes')}</Text>
                        </Col>
                        <Col xs={24} md={12}>
                            <Text >{t('admin_access')}:</Text>
                            <Text style={{ marginInlineStart: 8 }}>{user.is_admin ? t('yes') : t('no')}</Text>
                        </Col>
                        <Col xs={24} md={12}>
                            <Text >{t('verified')}:</Text>
                            <Text style={{ marginInlineStart: 8 }}>{user.is_verified ? t('yes') : t('no')}</Text>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Divider style={{ borderColor: 'gray', fontWeight:'normal' }} orientation="left">{t('account_details')}</Divider>
            <Row gutter={[16, 16]}>
                <Col xs={24} md={12}>
                    <Text >{t('created_at')}:</Text>
                    <Text style={{ marginInlineStart: 8 }}>{moment(user.created_at).format('YYYY-MM-DD HH:mm:ss')}</Text>
                </Col>
                <Col xs={24} md={12}>
                    <Text >{t('updated_at')}:</Text>
                    <Text style={{ marginInlineStart: 8 }}>{moment(user.updated_at).format('YYYY-MM-DD HH:mm:ss')}</Text>
                </Col>
                <Col xs={24} md={12}>
                    <Text >{t('welcome_credit_at')}:</Text>
                    <Text style={{ marginInlineStart: 8 }}>
                        {user.welcome_credit_at ? moment(user.welcome_credit_at).format('YYYY-MM-DD HH:mm:ss') : t('not_available')}
                    </Text>
                </Col>
                <Col xs={24} md={12}>
                    <Text >{t('discount_added_at')}:</Text>
                    <Text style={{ marginInlineStart: 8 }}>
                        {user.discount_added_at
                            ? moment(user.discount_added_at).format('YYYY-MM-DD HH:mm:ss')
                            : t('not_available')}
                    </Text>
                </Col>
                <Col xs={24} md={12}>
                    <Text >{t('discount_percentage')}:</Text>
                    <Text style={{ marginInlineStart: 8 }}>{user.discount_percentage}%</Text>
                </Col>
                <Col xs={24} md={12}>
                    <Text >{t('discount_expiry')}:</Text>
                    <Text style={{ marginInlineStart: 8 }}>
                        {user.discount_expiry ? moment(user.discount_expiry).format('YYYY-MM-DD') : t('not_available')}
                    </Text>
                </Col>
                <Col xs={24} md={12}>
                    <Text >{t('discount_added_by')}:</Text>
                    <Text style={{ marginInlineStart: 8 }}>
                        {user.discount_added_by?.full_name || t('not_available')}
                    </Text>
                </Col>
                <Col xs={24} md={12}>
                    <Text >{t('note')}:</Text>
                    <Text style={{ marginInlineStart: 8 }}>{user.note || t('not_available')}</Text>
                </Col>
            </Row>
            <Divider style={{ borderColor: 'gray', fontWeight:'normal' }} orientation="left">{t('balance_details')}</Divider>
            <Row gutter={[16, 16]}>
                <Col xs={24} md={12}>
                    <Text >{t('available_coins')}:</Text>
                    <Text style={{ marginInlineStart: 8 }}>{user.balance?.available_coins || 0}</Text>
                </Col>
                <Col xs={24} md={12}>
                    <Text >{t('total_coins_bought')}:</Text>
                    <Text style={{ marginInlineStart: 8 }}>{user.balance?.total_coins_bought || 0}</Text>
                </Col>
                <Col xs={24} md={12}>
                    <Text >{t('total_coins_consumed')}:</Text>
                    <Text style={{ marginInlineStart: 8 }}>{user.balance?.total_coins_consumed || 0}</Text>
                </Col>
            </Row>
        </>
    );
};

export default UserInfo;
